/// <amd-module name="SuiteCommerce.Blog.Pagination.Button.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.Button.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Pagination.Button.Model"], function (require, exports, Backbone_1, Pagination_Button_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PaginationButtonCollection = void 0;
    var PaginationButtonCollection = /** @class */ (function (_super) {
        __extends(PaginationButtonCollection, _super);
        function PaginationButtonCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = Pagination_Button_Model_1.PaginationButtonModel;
            return _this;
        }
        return PaginationButtonCollection;
    }(Backbone_1.Collection));
    exports.PaginationButtonCollection = PaginationButtonCollection;
});
